import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { screens } from '@yonderland/andes-react';
import { HtmlInclude } from '../common/html-include/HtmlInclude';
const BOX_ID = 'header-box-offset';
export const ContentDetailHeaderBoxOffset = ({ children }) => {
    const getStyleFragment = () => `
    @media (min-width: ${screens['2xl']}) {
        #${BOX_ID} {
            padding-left: calc((100vw - 1336px) / 2);
        }
    }
    @media (min-width: ${screens['3xl']}) {
        #${BOX_ID} {
            padding-left: 292px;
        }
    }
  `;
    return (_jsxs(_Fragment, { children: [_jsx(HtmlInclude, { styleFragment: getStyleFragment() }), _jsx("div", { id: BOX_ID, children: children })] }));
};
